import React from "react";
import * as Styled from "./Style";

const ApiError = (props) => {
  return props.error ? (
    <Styled.ApiErrorStyle>{props.error}</Styled.ApiErrorStyle>
  ) : (
    ""
  );
};

export default ApiError;
